<template>
  <div class="notifications">
    <template v-if="tableItems.length">
      <p class="h3">Список уведомлений</p>

      <AppTable
        :fields="tableFields"
        :items="tableItems"
        class="notifications__table"
        @sort="onSortTable"
      >
        <template #createdBy="{ createdBy }">
          <BaseLink :href="'/user/' + createdBy.id">
            {{ createdBy.name ?? '' }} {{ createdBy.surname ?? '' }}
          </BaseLink>
        </template>
      </AppTable>

      <div
        v-if="(paginationTotal / paginationPerPage) > 1"
        class="notifications__pagination-wrapper"
      >
        <AppPagination
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
          class="notifications__pagination"
        />
      </div>
    </template>
    <p v-else class="h3">Список уведомлений пуст.</p>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable'
import AppPagination from '@/components/Base/AppPagination'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'notificationsPage',
  components: {
    AppTable,
    AppPagination,
    BaseLink
  },
  data () {
    return {
      tableFields: [
        { key: 'createdBy', label: 'Автор', sortable: true, slot: true },
        { key: 'category', label: 'Категория', sortable: true },
        { key: 'createdAt', label: 'Дата уведомления', sortable: true }
      ],
      tableItems: [],
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10,
      order: 'DESC',
      sort: 'id'
    }
  },
  computed: {
    /**
     * Тело запроса
     */
    requestBody () {
      return {
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        sort: this.sort,
        order: this.order
      }
    }
  },
  watch: {
    /**
     * Отслеживанию изменение св-ва и подтягиваю новые данные таблицы
     */
    paginationCurrent: 'fetchNotifications'
  },
  async created () {
    await this.fetchNotifications()
  },
  methods: {
    async fetchNotifications () {
      const { data } = await this.$api.notification.list(this.requestBody)
      /* Записал общее колво уведомлений */
      this.paginationTotal = data.pages * this.paginationPerPage
      const items = data?.list ?? []

      this.tableItems = items.map(item => {
        const createdBy = item?.createdBy ?? {}
        const createdAt = item?.createdAt ?? ''
        const category = item?.category ?? ''

        return {
          createdBy, createdAt, category
        }
      })
    },
    /**
     * Записал новое значение поиска
     */
    onSearch (searchValue) {
      this.searchValue = searchValue
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchNotifications()
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications {
  &__table {
    margin-top: 30px;
  }

  &__pagination-wrapper {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
